export default __webpack_public_path__ + "static/media/flop-hit_0004_thumb.068cc052.jpg";